import { Outlet } from "react-router-dom";

const RootOutlet = () => {
  return <Outlet />;
};

export default RootOutlet;
